<template>
  <div class="leftContent">
    <div class="leftTitle" @click="$router.push('/')">
      <svg
        class="iconImg"
        t="1639580080457"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="5403"
      >
        <path
          d="M97.7 958.1c-21.7 0-33.7-12-33.7-33.7V588.6c0-21.7 12-33.7 33.7-33.7h335.7c21.7 0 33.7 12 33.7 33.7v335.7c0 21.7-12 33.7-33.7 33.7H97.7z m80.6-335.7c-25 0-46.9 21.9-46.9 46.9v174.6c0 25 21.9 46.9 46.9 46.9h174.6c25 0 46.9-21.9 46.9-46.9V669.2c0-25-21.9-46.9-46.9-46.9H178.3zM590.6 891c-21.7 0-33.7-12-33.7-33.7 0-21.7 12-33.7 33.7-33.7h335.7c21.7 0 33.7 12 33.7 33.7 0 21.7-12 33.7-33.7 33.7H590.6z m0-201.5c-21.7 0-33.7-12-33.7-33.7s12-33.7 33.7-33.7h335.7c21.7 0 33.7 12 33.7 33.7s-12 33.7-33.7 33.7H590.6z m0-224.2c-21.7 0-33.7-12-33.7-33.7V95.8c0-21.7 12-33.7 33.7-33.7h335.7c21.7 0 33.7 12 33.7 33.7v335.7c0 21.7-12 33.7-33.7 33.7H590.6z m80.5-335.8c-25.4 0-46.9 21.5-46.9 46.9V351c0 25.4 21.5 46.9 46.9 46.9h174.6c25 0 46.9-21.9 46.9-46.9V176.4c0-25-21.9-46.9-46.9-46.9H671.1zM97.7 465.3c-21.7 0-33.7-12-33.7-33.7V95.8c0-21.7 12-33.7 33.7-33.7h335.7c21.7 0 33.7 12 33.7 33.7v335.7c0 21.7-12 33.7-33.7 33.7H97.7z m80.6-335.8c-25 0-46.9 21.9-46.9 46.9V351c0 25 21.9 46.9 46.9 46.9h174.6c25 0 46.9-21.9 46.9-46.9V176.4c0-25-21.9-46.9-46.9-46.9H178.3z"
          p-id="5404"
        ></path>
      </svg>
      <span :class="{ newStyle: $collapse }" :title="title">{{ title }}</span>
    </div>
    <div class="leftMenu" ref="menuRef">
      <el-menu
        unique-opened
        :default-active="menuPath"
        class="el-menu-vertical-demo"
        :collapse="$collapse"
        text-color="#666"
        active-text-color="#4885FF"
      >
        <MenuItem
          ref="menuItemRef"
          v-for="submenu in $subRouterList"
          :key="submenu.id"
          :menuItem="submenu"
          :menuPath="menuPath"
        ></MenuItem>
      </el-menu>
    </div>
  </div>
</template>

<script>
import MenuItem from "./MenuItem.vue";
import { treeFindPath } from "@/utils/index.js";
export default {
  name: "leftMenu",
  components: { MenuItem },
  watch: {
    "$route.query.id": {
      immediate: true,
      deep: true,
      handler(val) {
        this.menuPath = val;
        this.changeBread(val);
      },
    },
  },
  data() {
    return {
      title: process.env.VUE_APP_LOGONAME,
      menuPath: "",
      distance: 0,
    };
  },
  created() {
    console.log("$subRouterList: ", this.$subRouterList);
  },
  methods: {
    changeBread(id) {
      let arr = treeFindPath(this.$routerList, (node) => node.tableId === id);
      let newBread = [];
      arr.forEach((item) => {
        newBread.push(item.name || item.menuName);
      });
      this.$store.commit("utils/SET_BREADLIST", newBread);
    },
  },
};
</script>

<style lang="stylus">
.leftContent
  width: 100%
  overflow: hidden
  .newStyle
    margin-left: 20px
    opacity: 0.5
  .leftTitle
    background: $headBgColor
    height: 50px
    display: flex
    align-items: center
    .iconImg
      flex-shrink: 0
      fill: $headIconColor
      margin-left: 22px
      margin-right: 10px
      width: 25px
      height: 25px
    span
      overflow: hidden
      white-space: nowrap
      text-overflow: ellipsis
      transition: all 0.5s
      font-size: 18px
      font-weight: 600
      color: $headValueColor
  .wordStyle
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis
    color: $leftTextColor
  .leftMenu
    height: calc(100vh - 50px)
    overflow: auto
    overflow-x: hidden
    position: relative
  .el-menu-vertical-demo
    text-align: left
    border: 0px
  .el-submenu .is-active .wordStyle
    color: $leftTextActive !important
  .el-submenu .is-active
    color: $leftTextActive !important
  .el-submenu__title
    background: $leftBgColor !important
    color: $leftTextColor !important
  .el-submenu__title i
    color: $leftTextColor !important
  .el-submenu__title:hover
    background: $leftHoverColor !important
  .el-submenu .el-menu-item
    background-color: $leftSonColor !important
  .el-submenu .el-menu-item:hover
    background-color: $leftHoverColor !important
  .horizontal-collapse-transition
    transition: 0s width ease-in-out, 0s padding-left ease-in-out, 0s padding-right ease-in-out
</style>
